$(document).on('turbo:load', function() {

  function updateQuestionLabels() {
    $('.question-row').each(function(index) {
      $(this).find('.question-label').text('Question ' + (index + 1));
      $(this).find('.order').val(index);
    });
  }

  function setupQuestionRow() {
    const questionRowFirst = $('.question-row').first();

    // Clear the inputs in the template
    const questionRowTemplate = questionRowFirst.clone();
    questionRowTemplate.find('input').val('');

    return questionRowTemplate;
  }
  const questionRowTemplate = setupQuestionRow();

  $('body').on('click', '.addAnotherQuestionButton', function(e) {
    e.preventDefault();
  
    // Use the questionRowTemplate instead of the first question row
    const cloneRow = questionRowTemplate.clone();
    cloneRow.find('select').val(null).change();
    const newIndex = $('.question-row').length; // Use the current number of rows for the index

    const elementsToUpdate = [
      { class: '.prompt-input', attr: 'prompt' },
      { class: '.sub-prompt-input', attr: 'sub_prompt' },
      { class: '.help-text-input', attr: 'help_text' },
      { class: '.answers-input', attr: 'possible_answers' },
      { class: '.type-select', attr: 'question_type' },
      { class: '.scale-min-input', attr: 'scale_min' },
      { class: '.scale-max-input', attr: 'scale_max' },
      { class: '.required-input', attr: 'required' },
      { class: '.order', attr: 'order' },
    ];

    for (let i = 0; i < elementsToUpdate.length; i++) {
      const element = elementsToUpdate[i];
      const input = cloneRow.find(element.class);
      const name = 'survey_template[survey_template_questions_attributes][' + newIndex + '][' + element.attr + ']';
      const id = 'survey_template_survey_template_questions_attributes_' + newIndex + '_' + element.attr;
      input.attr('name', name);
      input.attr('id', id);
      input.siblings('label').attr('for', id);
    }

    $('.question-row').last().after(cloneRow);

    updateQuestionLabels();
  });

  $('body').on('click', '.delete-question', function(e) {
    e.preventDefault();

    if ($('.question-row').length === 1) {
      alert('You cannot delete the last question.');
      return;
    }

    if (confirm('Are you sure you want to delete this question?')) {
      // Remove the row
      $(this).closest('.question-row').remove();
      updateQuestionLabels();
    }
  });

  $('body').on('click', '.move-question-up, .move-question-down', function(e) {
    // e.preventDefault();

    // Move the Row
    const row = $(this).closest('.question-row');
    if ($(this).hasClass('move-question-up')) row.prevAll('.question-row').first().before(row);
    else if ($(this).hasClass('move-question-down')) row.nextAll('.question-row').first().after(row);

    updateQuestionLabels();
  });

  $('body').on('change', '.type-select', function() {
    let selectedType = $(this).val();
    let parentCol = $(this).parents('.col-3');
    
    if (selectedType === 'single_select' || selectedType === 'multi_select') {
      parentCol.find('.answers-fields').removeClass('d-none');
    } else {
      parentCol.find('.answers-fields').addClass('d-none');
    }

    if (selectedType === 'scale') {
      parentCol.find('.scale-fields').removeClass('d-none');
    } else {
      parentCol.find('.scale-fields').addClass('d-none');
    }
  });

  $('#submit_button').on('click', function(e) {
    e.preventDefault();
  
    // trigger the form's submit event
    $('#survey_form').submit();
  });

  // MARK - EXECUTE

  $('.question-row').each(function() {
    $(this).find('.type-select').change();
  });
  updateQuestionLabels();
  
});
